import { useEffect, useState } from 'react';
import { connectionsApi } from '@/api/connections';
import './ViewDefinitionModal.css';

function CopyButton({ text }: { text: string }) {
  const [copied, setCopied] = useState(false);
  function copy() {
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }
  return (
    <button className={`vdm-copy ${copied ? 'copied' : ''}`} onClick={copy} title="Copiar SQL">
      {copied ? '✓ Copiado' : '⎘ Copiar'}
    </button>
  );
}

interface Props {
  connectionId: string;
  schema: string;
  view: string;
  onClose: () => void;
}

export function ViewDefinitionModal({ connectionId, schema, view, onClose }: Props) {
  const [sql, setSql]     = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    connectionsApi.getViewDefinition(connectionId, schema, view)
      .then(setSql)
      .catch(err => setError(err?.response?.data?.error ?? err?.message ?? 'Erro ao carregar definição'));
  }, [connectionId, schema, view]);

  return (
    <div className="vdm-overlay">
      <div className="vdm-panel">
        <div className="vdm-header">
          <span className="vdm-title">
            <span className="vdm-title-icon">◫</span>
            {schema}.{view}
          </span>
          <div className="vdm-actions">
            {sql && <CopyButton text={sql} />}
            <button className="vdm-close" onClick={onClose}>×</button>
          </div>
        </div>

        <div className="vdm-body">
          {!sql && !error && <div className="vdm-loading">Carregando...</div>}
          {error && <div className="vdm-error">{error}</div>}
          {sql && <pre className="vdm-code">{sql}</pre>}
        </div>
      </div>
    </div>
  );
}
